import { useMutation } from '@tanstack/react-query';

import type { CreateParticipationArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: CreateParticipationArgs) => {
  return employeeService.createParticipation(data);
};

export const useEmployeeCreateParticipationMutation = () => {
  return useMutation<unknown, unknown, CreateParticipationArgs>(mutationFn);
};
